"use client";

import React, { useState, useEffect, useCallback } from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LifeOnLifeMovement() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  const scrollTo = useCallback((index: number) => {
    api?.scrollTo(index);
  }, [api]);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const slides = [{
    text: "Providing a safe, loving, and community-focused living environment where every senior feels truly at home.",
    reference: "Our Mission"
  }, {
    text: "Experience a peaceful residential setting in McKinney, Texas, emphasizing a warm home-like atmosphere over institutional care.",
    reference: "Our Location"
  }, {
    text: "A dedicated team committed to providing high-quality elder care with compassion, professionalism, and attentive service.",
    reference: "Our Commitment"
  }];
  return <section data-section-id="40650" id="our-heartfelt-mission" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden dark bg-background text-foreground" ref={ref}>
            {}
            <div className="absolute inset-0 z-0">
                {}
                <div className="absolute inset-0 bg-[#091b3a]/30 z-10 mix-blend-multiply" />
                <div className="absolute inset-0 bg-black/10 z-10 !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1616978/img/2703_Cheverny_Dr.png)] bg-cover bg-center bg-no-repeat !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1616978/img/mckinney_monochromatic_map.png)]" /> {}
            </div>

            {}
            <div className={cn("relative z-20 container mx-auto flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
                {}
                

                {}
                <h1 className="text-4xl md:text-6xl lg:text-[72px] font-bold font-sans text-white leading-[1.1] mb-8 tracking-tight drop-shadow-lg max-w-5xl">
                    Our Heartfelt Mission
                </h1>

                {}
                <div className="w-full max-w-4xl mx-auto">
                    <Carousel setApi={setApi} className="w-full cursor-grab active:cursor-grabbing">
                        <CarouselContent>
                            {slides.map((slide, index) => <CarouselItem key={index} data-index={index}>
                                    <div className="flex flex-col items-center justify-center p-2 md:p-4">
                                        <p className="text-lg md:text-xl lg:text-2xl font-normal text-white/90 italic mb-4 max-w-3xl leading-relaxed">
                                            &ldquo;{slide.text}&rdquo;
                                        </p>
                                        <span className="text-sm md:text-base font-semibold text-[#ffbd00] uppercase tracking-[0.2em] drop-shadow-sm">
                                            {slide.reference}
                                        </span>
                                    </div>
                                </CarouselItem>)}
                        </CarouselContent>
                    </Carousel>
                </div>

                {}
                <div className="flex justify-center gap-4 mt-12 md:mt-16">
                    {Array.from({
          length: count
        }).map((_, index) => <button key={index} data-index={index} onClick={() => scrollTo(index)} className={cn("w-3 h-3 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/50", current === index ? "bg-[#ffbd00] scale-125 shadow-[0_0_10px_rgba(255,189,0,0.5)]" : "bg-white/30 hover:bg-white/50")} aria-label={`Go to slide ${index + 1}`} />)}
                </div>
            </div>
        </section>;
}